import { NormalizeApi } from "../normalizeApi";
const BASE_ENDPOINT = 'base.rpc.orders';
export const OrdersApi = NormalizeApi({
  view: `${BASE_ENDPOINT}.view`,
  list: `${BASE_ENDPOINT}.index`,
  pay: `${BASE_ENDPOINT}.pay`,
  finishByProduct: `${BASE_ENDPOINT}.finish-by-product`,
  cancelByProduct: `${BASE_ENDPOINT}.cancel-by-product`
});